<template>
  <div class="dr-launcher-container d-flex">
      <div :class="['dr-launcher-tree-container', {'dr-launcher-tree-container-shadow' : !isFixMenu, 'dr-launcher-tree-container-separator': isFixMenu, 
        'dr-launcher-tree-container-samll-screen-height' : isSmallScreen, 'dr-launcher-tree-container-height' : !isSmallScreen
      }]">
        <v-text-field
          v-if="!isLoading"
          v-model="searchText"
          prepend-inner-icon="mdi-magnify"
          clear-icon="mdi-close"
          :placeholder="$t('menuLayout.launcherMainMenu.searchTheMainMenu')"
          class="search-panel-text"
          hide-details="false"
          color="false"
          solo
          clearable
          v-on:keyup.enter="searchClick"
          @click:prepend-inner="searchClick"
          @click:clear="clearClick"
        />
        <template v-if="isLoading" class="d-flex">
          <div class="d-flex justify-center text--primary pt-6">{{ $t('menuLayout.drLauncherComponent.loadingData') }}</div>
          <circle-spiner class="d-flex justify-center dr-spiner-circle-loadre" size="40px" color="#757575" ></circle-spiner>
        </template>
        <vuescroll v-else :ops="ops">
          <div v-if="isSearchActive && searchItems && !searchItems.length" class="search-message" type="text" v-html="emptyResultText()"/>
          <v-treeview v-else :class="['dr-launcher-treeview', {'with-path' : isSearchActive}]" :items="isSearchActive ? searchItems : items" open-on-click item-key="codeMenu" active-class="selected-tree-item" activatable>
            <template v-slot:label="{ item }">
              <div v-if="isSearchActive && item.path && item.path.length" class="expanded-path">
                <span v-for="(part, index) in item.path" :key="index">{{ part }}</span>
              </div>
              <div class="d-flex node-content">
                <div class="tree-icon">
                  <circle-spiner v-if="isLoadingItemMenu && currentCodMenuItem == item.codeMenu" class="d-flex justify-center dr-spiner-circle-loadre" size="20px" color="#757575" ></circle-spiner>
                  <dr-svg v-else :image="item.image || defaultSvg" :color="iconColor" :size='iconSize' ></dr-svg>
                </div>
                <v-tooltip bottom open-delay="500">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on" class="dr-launcher-item-label" @click="isSearchActive ? openItem(item) : loadModule(item)" v-html="item.name"></div>
                  </template>
                  <span v-html="item.name"></span>
                </v-tooltip>
              </div>
            </template>
          </v-treeview>
        </vuescroll>
      </div>
    <div v-if="haveSelectMenu" :class="['d-flex', {'dr-launcher-tree-container-children': isFixMenu}]" style="width:100%" tabindex="0" @keydown.esc="closeChildrenMenu">
      <v-btn @click="closeChildrenMenu" icon class="btn-close">
        <v-icon>mdi mdi-close</v-icon>
      </v-btn>
      <dr-launcher-menu-children :items="selectMenu" :isAppInIFrame="isAppInIFrame" :baseUrl="baseUrl" :itemHaveInFavorite="itemHaveInFavorite" @removeFromFavorite="removeFromFavorite" @addToFavorite="addToFavorite" @changedCode="changedCode" @changeContextMenuItem="changeContextMenuItem"></dr-launcher-menu-children>
    </div>
  </div>
</template>
<script>

import { MainMenuApi as api } from '../../api/api.js'
import CircleSpiner from 'vue-spinner/src/ClipLoader.vue'
import DrLauncherMenuChildren from './dr-launcher-menu-children'
import drSvg from './dr-svg'
export default {
  name: 'dr-launcher-component',
  props: ['items', 'isLoading', 'favoriteModule', 'baseUrl', 'isFixMenu', 'isAppInIFrame', 'favoriteItems'],
  components: {
    CircleSpiner,
    'vuescroll': () => import('vuescroll'),
    DrLauncherMenuChildren,
    drSvg
  },
  data: () => ({
    basePath: process.env.VUE_APP_BASE_PATH,
    defaultSvg: 'IT',
    iconColor: 'rgb(var(--md-pallete-rgb-700))',
    ops: {
      bar: {
        background: '#aaa',
        size: '10px'
      },
      rail: {
        size: '10px'
      }
    },
    selectMenu: [],
    isLoadingItemMenu: false,
    currentCodMenuItem: '',
    iconSize: 20, 
    itemHaveInFavorite: false,
    isSearchActive: false,
    searchItems: [],
    searchText: ''
  }),
  created() {
    if (!this.isFixMenu) {
      this.selectMenu = this.favoriteModule
    }
  },
  computed: {
    haveSelectMenu() {
      return !!this.selectMenu.length
    },
    isSmallScreen() {
      if (this.isFixMenu) {
        return
      }
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md
    }
  },
  methods: {
    emptyResultText() {
      return this.$t('menuLayout.launcherMainMenu.thereAreNoSearchResults', { 0: `<i>"${this.searchText}"</i>` })
    },
    addToFavorite(item) {
      this.$emit('addToFavorite', item)
    },
    changeContextMenuItem(codeMenu) {
      let item = undefined
      item = this.favoriteItems.find(x => x.codeMenu === codeMenu)
      if (item) {
        this.itemHaveInFavorite = true
        return
      }

      for (let i = 0; i < this.favoriteModule.length; i++) {
        item = this.favoriteModule[i].children.find(x => x.codeMenu === codeMenu)
        if (!item) {
          this.itemHaveInFavorite = false
          continue
        }
        this.itemHaveInFavorite = true
        return
      }
    },
    removeFromFavorite(codeMenu) {
      this.$emit('removeFromFavorite', codeMenu)
    },
    closeChildrenMenu() {
      this.selectMenu = []
      this.$emit('setSignFunctionMenu', false)
    },
    isFolder(item) {
      return !item.shareParams || item.isFolder || (item.children && item.children.length)
    },
    async loadModule(value) {
      if (value.codeMenu == 'FAVORITE_MODULE') {
        this.selectMenu = this.favoriteModule
        this.$emit('setSignFunctionMenu', true)
        return
      }
      if (value.isFolder) {
        return
      }
      this.currentCodMenuItem = value.codeMenu
      this.isLoadingItemMenu = true
      let data = await api.getModule(value.codeMenu)
      this.$emit('changeChildren', data.data.iTEnterpriseMenuQuery.moduleContent.children)
      this.selectMenu = data.data.iTEnterpriseMenuQuery.moduleContent.children
      this.$emit('setSignFunctionMenu', true)
      this.isLoadingItemMenu = false
    },
    changedCode(value) {
      this.$emit('changedCode', value)
    },
    addModuleInMenu(array, itemMenu, newChildren) {
      array.map(x => {
        if (x == itemMenu) {
          x.children = newChildren.children
        } else {
          if (x.children) {
            this.addModuleInMenu(x.children, itemMenu, newChildren)
          }
        }
      })
    },
    async searchClick() {
      this.isSearchActive = true
      let data = await api.getSearchResult(this.searchText)
      this.searchItems = data.data.iTEnterpriseMenuQuery.searchResult.items
    },
    clearClick() {
      this.isSearchActive = false
      this.searchItems = []
    },
    openItem(item) {
      if (this.isFolder(item)) {
        return
      }
      let menuObject = {codeMenu: item.codeMenu,
        shareParams: item.shareParams,
        ...(item.httpLink && { httpLink: item.httpLink }) // если в item есть httpLink
      }
      this.$emit('changedCode', menuObject)
      this.$emit('closeDialog', false)
    }
  }
}
</script>
<style>
.dr-launcher-item-label {
	overflow: hidden;
	text-overflow: ellipsis;
  color: #000000de;
  font-size: var(--main-menu-font-size);
  width: 100%;
}
.dr-launcher-container {
  max-height: 100%;
  height: 100%;
}
.dr-launcher-treeview {
  max-width: var(--main-menu-width);
}
.scroll-area {
  margin: auto;
  max-height: 100%;
}
.dr-launcher-tree-container {
  min-width: var(--main-menu-width);
  background: white;
  box-shadow: 0px 0px 1px 0px #b2b2b2;
  z-index: 2;
}
.dr-launcher-tree-container-height {
  height: calc(100vh - var(--top-toolbar-height));
}
.dr-launcher-tree-container-samll-screen-height {
  height: calc(100vh - var(--top-toolbar-height));
}
.dr-launcher-tree-container-shadow {
  box-shadow: 0px 7px 15px 0px #333;
}
.dr-launcher-tree-container-children {
  position: absolute;
  background: white;
  z-index: 2;
  left: var(--main-menu-width);
  margin-left: 1px;
}
.btn-close {
  position: fixed;
  right: 0px;
}
.dr-launcher-tree-container .v-treeview-node {
  padding: 1px 0px;
}
.dr-launcher-tree-container .v-treeview-node__root:hover {
  background-color: var(--md-pallete-50)
}
.dr-launcher-tree-container .v-treeview-node__root{
  min-height: 30px !important;
  margin-right: 3px;
}
.dr-launcher-tree-container .selected-tree-item {
  background-color: var(--md-pallete-100);
}

.dr-launcher-tree-container .selected-tree-item, .dr-launcher-tree-container .v-treeview-node__root:hover  {
  border-top-right-radius: 999px;
  border-bottom-right-radius: 999px;
}
.dr-launcher-tree-container .tree-icon {
  display: flex;
  padding-right: 8px;
}

.search-panel-text {
  padding: 0px;
  border-bottom: 1px solid #eee;
  font-size: var(--main-menu-font-size);
  font-weight: 500;
}
.search-panel-text.v-text-field.v-text-field--solo .v-input__control {
  min-height: unset;
}
.search-panel-text.v-text-field.v-text-field--solo .v-input__control .v-input__slot {
  padding: 0px;
}
.search-panel-text.v-text-field.v-text-field--solo .v-input__control .v-input__slot .v-input__prepend-inner, .search-panel-text.v-text-field.v-text-field--solo .v-input__control .v-input__slot .v-input__append-inner {
  padding: var(--main-menu-treeview-item-padding-top-bot) 10px;
}
.search-panel-text .v-input__prepend-inner:hover, .search-panel-text .v-input__append-inner:hover {
  background: var(--md-pallete-50);
}


.node-content {
  align-items: center;
}

.search-panel-text * {
  box-shadow: unset !important;
}

.dr-launcher-treeview em {
  font-style: normal;
  background: #c6d7fe none repeat 0 0;
}

.node-content {
  align-items: center;
}

.with-path .v-treeview-node__root .node-content {
  margin-bottom: 15px;
  margin-left: 4px;
}

.with-path .v-treeview-node__children .node-content {
  margin: 0px !important;
}

.with-path .tree-icon {
  margin-right: 18px !important;
}

.with-path .selected-tree-item, .with-path .v-treeview-node__root:hover  {
  background: #efefef;
  border-radius: unset !important;
}

.with-path .v-treeview-node__root:hover .expanded-path {
  color: var(--md-pallete-800);
}

.with-path .v-treeview-node__level {
  display: none !important;
}

.dr-launcher-treeview .expanded-path {
  overflow: hidden;
  font-size: 14px;
  line-height: 17px;
  color: var(--md-pallete-400);
}

.dr-launcher-treeview .expanded-path span {
  display: block;
  white-space: pre-wrap;
}

.dr-launcher-treeview .expanded-path span:not(:first-child)::before {
  content: "└ ";
	color: var(--md-pallete-100) !important;
}

.dr-launcher-treeview .expanded-path span:nth-child(3) {
  padding-left: 1em ;
}

.dr-launcher-treeview .expanded-path span:nth-child(4) {
  padding-left: 2em ;
}

.dr-launcher-treeview .expanded-path span:nth-child(5) {
  padding-left: 3em ;
}

.dr-launcher-treeview .expanded-path span:nth-child(6) {
  padding-left: 4em ;
}

.dr-launcher-treeview .expanded-path span:nth-child(7) {
  padding-left: 5em ;
}

.dr-launcher-treeview .expanded-path span:nth-child(8) {
  padding-left: 6em ;
}

.dr-launcher-treeview .expanded-path span:nth-child(9) {
  padding-left: 7em ;
}

.dr-launcher-treeview .expanded-path span:nth-child(10) {
  padding-left: 8em ;
}

.search-message {
    text-align: center;
    padding: 10px;
    background: #f6f7f7;
}
</style>